<section class="user-profile-change">
  @if(isLoading) {
  <div class="loading-container">
    <seds-loaders-spinner mode="indeterminate"></seds-loaders-spinner>
  </div>
  }
<div class="card__header">
  <h2>Alterar perfil de usuário</h2>
  <span class="close-btn material-icons" launchLabel="Fechar" launchSection="Clique" launchSiteSection="PortalDeLogons"
    plAnalyticsButton (click)="closeSideNav()">
    close
  </span>
</div>
<seds-alert-basic *ngIf="showSuccessAlert && lastSelectedProfile?.key === 'ACCESS_ADMIN'"
  color="success"
  headerTitle="Perfil Alterado"
  contentText="Agora este perfil tem acesso ao Portal de Logons.">
</seds-alert-basic>
<seds-alert-basic *ngIf="showSuccessAlert && lastSelectedProfile?.key !== 'ACCESS_ADMIN'"
  color="success"
  headerTitle="Perfil Alterado!"
  contentText="Este perfil não tem mais acesso ao Portal de Logons">
</seds-alert-basic>
<form class="user-profile-change__form" [formGroup]="profileChangeForm">
  <seds-form-field-text label="Usuário">
    <input matInput readonly name="logon" formControlName="logon" id="logon" class="readonly-input" />
  </seds-form-field-text>
  <seds-form-field-dropdown (modelChange)="modelChange($event)" label="Perfil *" [tabindex]="0" name="profile"  [(model)]="userProfile"
    [modelOptions]="{standalone: true}" [optionList]="profileList" valueField="key"
    textField="value"></seds-form-field-dropdown>

  <div class="profile-message" *ngIf="userProfile === 'USER'">
    <div class="alert alert-info">
      <span class="material-icons">info</span>
      <p>O perfil Usuário não tem acesso ao Portal de Logons. Ele pode acessar o Menu de Produtos e os produtos
        disponíveis para sua conta.</p>
    </div>
  </div>
  <div class="profile-message" *ngIf="userProfile === 'ACCESS_ADMIN'">
    <div class="alert alert-info">
      <span class="material-icons">info</span>
      <p>O perfil Administrador de acesso pode acessar o Portal de Logons para visualizar e gerenciar todos os usuários,
        além de usar os produtos disponíveis em sua conta.</p>
    </div>
  </div>
</form>
</section>

<pl-action-footer>
  <div class="action-footer__back" (click)="closeSideNav()">
    <span class="material-icons">arrow_back_ios</span>
    <span>Voltar</span>
  </div>

  <seds-basic-button type="button" title="Alterar perfil" [disabled]="isActionDisabled" (click)="save()">
    <ng-container>
      Alterar perfil
    </ng-container>
  </seds-basic-button>
</pl-action-footer>